import { render, staticRenderFns } from "./FederationPlanList.vue?vue&type=template&id=2996ba26&scoped=true"
import script from "./FederationPlanList.vue?vue&type=script&lang=js"
export * from "./FederationPlanList.vue?vue&type=script&lang=js"
import style0 from "./FederationPlanList.vue?vue&type=style&index=0&id=2996ba26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996ba26",
  null
  
)

export default component.exports